import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from 'axios';

function Header() {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    // Retrieve username from local storage
    const username = localStorage.getItem('username');

    const handleLogout = () => {
        const accessToken = localStorage.getItem('accessToken');

        // Try to logout from the server if we have a token
        if (accessToken) {
            axios.post('https://iscreenfix.com/api/logout/', {}, {
                headers: {
                    Authorization: `Token ${accessToken}`
                }
            }).finally(() => {
                // Clear local storage and reload regardless of API response
                localStorage.removeItem('accessToken');
                localStorage.removeItem('username');
                window.location.reload();
            }).catch((error) => {
                console.error("Logout failed", error);
            });
        } else {
            // If no token, just clear local storage and reload
            localStorage.removeItem('accessToken');
            localStorage.removeItem('username');
            window.location.reload();
        }
    };

    return (
        <header className="cm-header">
            <div className="header-top bg-blue">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-10">
                            <div className="d-block d-md-flex justify-content-center justify-content-xl-start">
                                <div className="block text-gray mr-35">
                                    <span className="icon text-primary fas fa-phone-alt mr-15" />
                                    1 (843) 900 4668
                                </div>
                                <div className="block text-gray mr-35">
                                    <span className="icon text-primary fas fa-envelope mr-15" />
                                    info@iscreenfix.com
                                </div>
                                <div className="block text-gray">
                                    <span className="icon text-primary fas fa-home mr-15" />
                                    981 Hackler St, Myrtle Beach, SC
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-2 d-none d-xl-block">
                            <div className="block d-flex justify-content-end">
                                <Link to={'https://www.facebook.com/iscreenfixmb/'} className="text-primary initiate-scripts"><span className="icon fab fa-facebook-f border-right-0" /></Link>
                                <Link to={'https://twitter.com/iscreenfix'} className="text-primary initiate-scripts"><span className="icon fab fa-twitter border-right-0" /></Link>
                               {/*} <Link to={'https://www.instagram.com/iscreenfix_myrtlebeach/?hl=en'} className="text-primary initiate-scripts"><span className="icon fab fa-instagram" /></Link>*/}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="header">
                <div className="container h-100">
                    <div className="row h-100 align-content-center">
                        <div className="col-md-12">
                            <nav className="navbar navbar-expand-lg navbar-light px-0">
                                <Link className="navbar-brand initiate-scripts" to={'/'}>
                                    <img src={process.env.PUBLIC_URL + '/assets/images/logo.png'} alt="logo" />
                                </Link>
                                <button
                                    className="navbar-toggler border-0 p-0"
                                    type="button"
                                    data-toggle="collapse"
                                    data-target="#navLinks"
                                    aria-controls="navLinks"
                                    aria-expanded="false">

                                    <span className="navbar-toggler-icon" />
                                </button>

                                <div className="collapse navbar-collapse" id="navLinks">
                                    <ul className="navbar-nav ml-auto align-items-center">
                                        <li className="nav-item dropdown active">
                                            <Link
                                                className="nav-link initiate-scripts" //dropdown-toggle
                                                to={'/'}
                                                role="button"
                                                //data-toggle="dropdown"
                                                aria-haspopup="true"
                                                aria-expanded="false">
                                                Home <span className="text-primary"></span>
                                            </Link>

                                            {/*} <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                                                    <li><Link className="dropdown-item initiate-scripts" to={'/home-one'}>Home 01</Link></li>
                                                    <li><Link className="dropdown-item initiate-scripts" to={'/home-two'}>Home 02</Link></li>
                                                    <li><Link className="dropdown-item initiate-scripts" to={'/home-three'}>Home 03</Link></li>
                                                </ul> */}
                                        </li>
                                        <li className="nav-item">
                                            <Link className="nav-link initiate-scripts" to={'/services'}>Services</Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link
                                                className="nav-link initiate-scripts" to={'/blog'}>Blog</Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className="nav-link initiate-scripts" to={'/team'}>Team</Link>
                                        </li>
                                        <li className="nav-item dropdown">
                                            <Link className="nav-link initiate-scripts" to={'/contact'}>Contact Us</Link>
                                        </li>
                                        <div className="block d-flex mt-3 mt-lg-0">
                                            {/*
                                                <span className="icon fas fa-share-alt text-dark" role="button" />
                                                <span className="icon fas fa-search text-dark search-toggle" role="button" />
                                                <Link className="icon pr-0 pt-0 pb-0 text-dark initiate-scripts" to={'/cart'}>
                                                    <span className="fas fa-shopping-bag" />
                                                </Link>
                                                */}
                                            {username ? (
                                                <div className="user-info ml-3" style={{ position: 'relative' }}>
                                                    <div
                                                        style={{ cursor: 'pointer' }}
                                                        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                                                    >
                                                        <span className="icon fas fa-user" />
                                                        <span className="ml-2">{username}</span>
                                                    </div>
                                                    {isDropdownOpen && (
                                                        <div style={{
                                                            position: 'absolute',
                                                            right: 0,
                                                            backgroundColor: 'white',
                                                            boxShadow: '0 2px 5px rgba(0,0,0,.2)',
                                                            borderRadius: '5px',
                                                            width: '150px',
                                                            zIndex: 1000,
                                                        }}>
                                                            <div
                                                                style={{ padding: '10px', cursor: 'pointer' }}
                                                                onClick={handleLogout}
                                                            >
                                                                Logout
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            ) : (
                                                <div className="user-info ml-3">
                                                    <Link to="/login" style={{ textDecoration: 'none', color: 'inherit' }}>
                                                        <span className="icon fas fa-user" />
                                                        <span className="ml-2">Sign In</span>
                                                    </Link>
                                                </div>
                                            )}
                                        </div>
                                    </ul>
                                </div>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
}

export default Header;